import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackshipmentService {
  private getEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/Get';
  private getAllEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GetAll';
  private getDropDownEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GetDropDownForTrackShipment';

  private getStep1DropdownEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GetStep1Dropdown';

  private getStep1ByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/getStep1ById';
  private getStep1OnDateChangeEnpoind = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GetStep1OnChangeDate'; 
  private getStep2ByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/getStep2ById';
  private getStep3ByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/getStep3ById';
  private getStep4ByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/getStep4ById';
  private getStep5ByIdEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/getStep5ById';

  private step1DisposerUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/DisposerStep1Update';
  private step1WasteCoConfirmEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/WasteCoStep1Confirm';
  private AdminStep1UpdateEndpint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AdminStep1Update';

  private step2RegAdminUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/RegAdminStep2Update';
  private step2WasteCoUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/WasteCoStep2Update';
  private step2GenerateKorOr2Endpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GenerateKorOr2';
  private step2GenerateUsageMaterialEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GenerateUsageMaterial';
  private step2GenerateTransportChecklistEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/GenerateTransportChecklist';
  private AdminStep2UpdateEndpint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AdminStep2Update';

  private step3WasteCoUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/WasteCoStep3Update';
  private step3WasteCoUploadEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/WasteCoStep3Upload';
  private step3RegAdminUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/RegAdminStep3DiwReport';
  private AdminStep3UplodeEndpint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AdminStep3Upload';

  private step4AccountUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AccountStep4Update';
  private step4AccountApproveEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AccountStep4Approve';


  private step5DisposerUpdateEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/DisposerStep5Update';
  private step5DisposerUploadEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/DisposerStep5UploadFile';
  private step5WasteCoUploadEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/WasteCoStep5Update';
  private step5AdminUploadEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/AdminStep5UploadFile';

  private deleteShipmentByIdEndponit = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/DeleteShipmentById';




  private step5RegAdminApproveEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/RegAdminStep5Update';

  private wasteCoStep3ConfirmChecklistEndpoint = environment.ECO_WASTE_SERVICE_URL + '/TrackShipment/wasteCoStep3ConfirmChecklist';
  private criteria: any = {};





  constructor(private http: HttpClient) { }

  setCriteria(criteria: any) {
    this.criteria = criteria;
  }

  getCriteria() {
    return this.criteria;
  }

  clearCriteria() {
    this.criteria = {};
  }

  getShipmentData(requestBody: any): Observable<any> {
    return this.http.post<any>(this.getAllEndpoint, requestBody);
  }

  getDropDownForTrackShipment(): Observable<any> {
    return this.http.get<any[]>(this.getDropDownEndpoint);
  }

  getTrackShipment(): Observable<any> {
    return this.http.get<any[]>(this.getDropDownEndpoint);
  }

  getShipments(params: {
    wasteId?: number;
    subPlantId?: number;
    startDate?: string;
    endDate?: string;
    categoryId?: number;
    subCategoryId?: number;
    disposerId?: number;
    progressId?: number;
    keyword?: string;
  }): Observable<any> {
    let httpParams = new HttpParams();

    if (params.keyword != null) {
      httpParams = httpParams.set('Keyword', params.keyword.toString());
    }
    if (params.subPlantId != null) {
      httpParams = httpParams.set('SubPlantId', params.subPlantId.toString());
    }
    if (params.wasteId != null) {
      httpParams = httpParams.set('WasteId', params.wasteId.toString());
    }
    if (params.categoryId != null) {
      httpParams = httpParams.set('CategoryId', params.categoryId.toString());
    }
    if (params.subCategoryId != null) {
      httpParams = httpParams.set('SubCategoryId', params.subCategoryId.toString());
    }
    if (params.disposerId != null) {
      httpParams = httpParams.set('DisposerId', params.disposerId.toString());
    }
    if (params.progressId != null) {
      httpParams = httpParams.set('ProgressId', params.progressId.toString());
    }
    if (params.startDate != null) {
      httpParams = httpParams.set('StartDate', params.startDate);
    }
    if (params.endDate != null) {
      httpParams = httpParams.set('EndDate', params.endDate);
    }

    const url = this.getEndpoint + '?' + httpParams.toString();
    console.log('API Request URL:', url);

    return this.http.get(this.getEndpoint, { params: httpParams });
  }


  getStep1ById(shipmentId: number): Observable<any> {
    const url = `${this.getStep1ByIdEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  getStep1OnDateChange(shipmentId: number, date: any): Observable<any> {
    const url = `${this.getStep1OnDateChangeEnpoind}?shipmentId=${shipmentId}&receivedDate=${date}`;
    return this.http.get<any>(url);
  }

  getStep2ById(shipmentId: number): Observable<any> {
    const url = `${this.getStep2ByIdEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  getStep3ById(shipmentId: number): Observable<any> {
    const url = `${this.getStep3ByIdEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  getStep4ById(shipmentId: number): Observable<any> {
    const url = `${this.getStep4ByIdEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  getStep5ById(shipmentId: number): Observable<any> {
    const url = `${this.getStep5ByIdEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  getStep1Dropdown(shipmentId: number): Observable<any> {
    const url = `${this.getStep1DropdownEndpoint}?shipmentId=${shipmentId}`;
    return this.http.get<any>(url);
  }

  disposerStep1Update(formData: any): Observable<any> {
    console.log("Service", formData)
    return this.http.put<any>(this.step1DisposerUpdateEndpoint, formData);
  }

  wasteCoStep1Confirm(formData: any): Observable<any> {
    console.log("Service", formData)
    return this.http.put<any>(this.step1WasteCoConfirmEndpoint, formData);
  }

  adminStep1Update(formData: any): Observable<any> {
    console.log("Service", formData)
    return this.http.put<any>(this.AdminStep1UpdateEndpint, formData);
  }

  updateStep2ByRegAdmin(formData: FormData): Observable<any> {
    console.log(formData)
    return this.http.put(this.step2RegAdminUpdateEndpoint, formData);
  }

  updateStep2ByWasteCo(formData: any): Observable<any> {
    console.log("Service", formData)
    return this.http.put<any>(this.step2WasteCoUpdateEndpoint, formData);
  }

  adminStep2Update(formData: any): Observable<any> {
    console.log("Service", formData)
    return this.http.put<any>(this.AdminStep2UpdateEndpint, formData);
  }

  generateKorOr2(shipmentId: number): Observable<Blob> {
    const url = `${this.step2GenerateKorOr2Endpoint}?id=${shipmentId}`;
    return this.http.post(url, {}, { responseType: 'blob' });
  }

  generatUsageMaterial(shipmentId: number): Observable<Blob> {
    const url = `${this.step2GenerateUsageMaterialEndpoint}?id=${shipmentId}`;
    return this.http.post(url, {}, { responseType: 'blob' });
  }

  generateTransportChecklist(shipmentId: number): Observable<Blob> {
    const url = `${this.step2GenerateTransportChecklistEndpoint}?id=${shipmentId}`;
    return this.http.post(url, {}, { responseType: 'blob' });
  }

  updateStep3ByWasteCo(formData: any): Observable<any> {
    return this.http.put(this.step3WasteCoUpdateEndpoint, formData);
  }

  uploadStep3ByWasteCo(formData: FormData): Observable<any> {
    // No need to set 'Content-Type' manually
    const headers = new HttpHeaders({
      'Accept': '*/*' // This is optional
    });

    return this.http.put(this.step3WasteCoUploadEndpoint, formData, { headers });
  }

  adminStep3Upload(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': '*/*'
    });

    return this.http.put(this.AdminStep3UplodeEndpint, formData, { headers });
  }

  updateStep3ByRegAdmin(id: number): Observable<any> {
    const url = `${this.step3RegAdminUpdateEndpoint}?id=${id}`;
    console.log('Request URL:', url);
    return this.http.put(url, null);
  }

  updateStep4ByAccount(formData: any): Observable<any> {
    return this.http.put(this.step4AccountUpdateEndpoint, formData);
  }

  approveStep4ByAccount(shipmentId: any): Observable<any> {
    const url = `${this.step4AccountApproveEndpoint}?shipmentId=${shipmentId}`;
    return this.http.put(url, null);
  }



  updateStep5ByDisposer(formData: any): Observable<any> {
    console.log(formData)
    return this.http.put(this.step5DisposerUpdateEndpoint, formData);
  }

  uploadStep5ByDisposer(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': '*/*'
    });
    return this.http.put(this.step5DisposerUploadEndpoint, formData, { headers });
  }
  
  uploadStep5ByWasteCo(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': '*/*'
    });
    return this.http.put(this.step5WasteCoUploadEndpoint, formData, { headers });
  }

  uploadStep5ByAdmin(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': '*/*'
    });
    return this.http.put(this.step5AdminUploadEndpoint, formData, { headers });
  }



  approveStep5ByRegAdmin(formData: any): Observable<any> {
    return this.http.put(this.step5RegAdminApproveEndpoint, formData);
  }

  deleteShipmentById(shipmentId: number): Observable<any> {
    console.log(shipmentId)
    const url = `${this.deleteShipmentByIdEndponit}?id=${shipmentId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'accept': '*/*'
    });
    return this.http.delete(url, { headers });
  }

  wasteCoConfirmCheckList(formData: any, shipmentId: string): Observable<any> {
    const url = `${this.wasteCoStep3ConfirmChecklistEndpoint}?shipmentId=${shipmentId}`;
    return this.http.post(url, formData);
  }
  





}